import { render, staticRenderFns } from "./studyAchievements.vue?vue&type=template&id=172262a4&scoped=true"
import script from "./studyAchievements.vue?vue&type=script&lang=js"
export * from "./studyAchievements.vue?vue&type=script&lang=js"
import style0 from "./studyAchievements.vue?vue&type=style&index=0&id=172262a4&prod&lang=scss&scoped=true"
import style1 from "./studyAchievements.vue?vue&type=style&index=1&id=172262a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172262a4",
  null
  
)

export default component.exports